import api from "./api";
import { getConfig } from "@/utils/config";

/** پسوند نمای پی‌دی‌اف در مرورگر (مثل آریازار)؛ بخشی از URL نیست؛ فقط روی نمای کلاینت اثر می‌گذارد. */
export const DOCUMENT_LIST_REPORT_PDF_VIEWER_HASH =
  "#toolbar=1&navpanes=0&scrollbar=1&view=FitH";

/**
 * آدرس مطلق گزارش PDF لیست اسناد برای کاربر لاگین‌شده.
 * Backend: GET /api/v1/trading/report/documentlistreport — پارامترها از اطلاعات شخص.
 *
 * @param {string} baseUrl — معمولا همان axios baseURL (مثلا https://host/api/v1)
 * @param {{ fiscalId: number|string, branchId: number|string, accountId: number|string }} ids
 */
export function buildDocumentListReportPdfUrl(baseUrl, { fiscalId, branchId, accountId }) {
  const root = String(baseUrl || "").replace(/\/$/, "");
  const q = new URLSearchParams();
  q.set("FiscalId", String(fiscalId));
  q.set("BranchId", String(branchId));
  q.set("AccountId", String(accountId));
  return `${root}/trading/report/documentlistreport?${q}${DOCUMENT_LIST_REPORT_PDF_VIEWER_HASH}`;
}

function getEffectiveApiRoot() {
  const fromAxios = api.defaults.baseURL;
  const fromEnv = getConfig("VITE_API_BASE_URL", "");
  return String(fromAxios || fromEnv || "").replace(/\/$/, "");
}

/**
 * از /trading/person/info مقادیر fiscalId، branchId، accountId را می‌گیرد و URL نهایی PDF را می‌سازد.
 */
export async function getDocumentListReportPdfUrlForCurrentUser() {
  const res = await api.get("/trading/person/info");
  const data = res.data?.data ?? res.data;
  const fiscalId = data?.fiscalId;
  const branchId = data?.branchId;
  const accountId = data?.accountId;

  if (fiscalId == null || branchId == null || accountId == null) {
    throw new Error(
      "شناسه‌های گزارش (سال مالی، شعبه یا حساب) در پروفایل وجود ندارد."
    );
  }

  return buildDocumentListReportPdfUrl(getEffectiveApiRoot(), {
    fiscalId,
    branchId,
    accountId,
  });
}
